/* eslint-disable prefer-template */

const INPUT_RESTRICTIONS = ['%'];

export default {
    /**
     * Nombre del componente
     */
    name: 'YuriInput',

    /**
     * @override
     */
    data() {
        return {
            componentKey: 0
        };
    },

    props: {
        id: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: false,
            default: 'text'
        },
        maxlength: {
            type: Number,
            required: false,
            default: 100
        },
        capitalize: {
            type: Boolean,
            required: false,
            default: false
        },
        placeholder: {
            type: String,
            required: false
        },
        tabindex: {
            type: Number,
            required: false
        }
    },

    methods: {
        /**
         * Comprobamos si el valor insertado es número si no lo es, no lo inserta
         * @param {Event} $event evento del input
         */
        onlyNumbers($event) {
            if (!this.isDeleting($event.keyCode)) {
                if (this.isCopyPaste($event)) {
                    return;
                }
                if (($event.keyCode < 48 || $event.keyCode > 57) && ($event.keyCode < 96 || $event.keyCode > 105)
                || INPUT_RESTRICTIONS.includes($event.key)) {
                    $event.preventDefault();
                }
            }
        },
        /**
         * Comprobamos si el valor insertado es número si lo es, no lo inserta
         * @param {Event} $event evento del input
         */
        notNumbers($event) {
            if (!this.isDeleting($event.keyCode)) {
                if (($event.keyCode >= 48 && $event.keyCode <= 57) || ($event.keyCode >= 96 && $event.keyCode <= 105)) {
                    $event.preventDefault();
                }
            }
        },

        /**
         * Capitalize input
         */
        capitalizeWords() {
            const value = document.getElementById(this.id).value;
            const exceptions = ['de', 'la', 'a', 'en', 'que'];
            if (this.capitalize) {
                const textParts = value.split(' ');
                let capitalized = '';
                textParts.forEach(s => {
                    if (exceptions.indexOf(s.toLowerCase()) < 0) {
                        capitalized += s.charAt(0).toUpperCase() + s.slice(1) + ' ';
                    } else {
                        capitalized += s.toLowerCase() + ' ';
                    }
                });
                if (capitalized.trim() !== value.trim()) {
                    this.$emit('input', capitalized.trim());
                    this.componentKey += 1;
                    this.$nextTick(() => {
                        document.getElementById(this.id).focus();
                        const val = document.getElementById(this.id).value;
                        document.getElementById(this.id).value = '';
                        document.getElementById(this.id).value = val;
                    });
                }
            }
        },
        /**
         * Check if is deleting the value
         * @param {Number} keyCode key code of input
         * @return {Boolea} whether is deleting or not
         */
        isDeleting(keyCode) {
            let isDeleting = false;
            switch (keyCode) {
                case 8:
                    // Backspace
                    isDeleting = true;
                    break;
                case 46:
                    // Delete
                    isDeleting = true;
                    break;
                default:
                    break;
            }
            return isDeleting;
        },
        /**
         * Check if is copy and paste
         * @param {Number} event event of input
         * @return {Boolea} return if it is copy paste or cut
         */
        isCopyPaste(event) {
            const CVX_keys = [86, 67, 88];
            let isPaste = false;
            if (event && CVX_keys.includes(event.keyCode) && event.ctrlKey) {
                isPaste = true;
            }
            return isPaste;
        }
    }
};
